import {
  useGetSortFromUrl,
  useGetPaginationFromUrl,
  useGetFiltersUrl,
  useGetInitialFiltersFromUrl,
} from 'shared/lib/hooks';

import { ContractorCampaignsSort, ContractorCampaignsFilter, ContractorCampaignsPageFilter } from '../model';

export const useGetCampaignContractorFilter = (initialSort?: Record<string, string>) => {
  const sorting = useGetSortFromUrl({ ...ContractorCampaignsSort, ...ContractorCampaignsFilter }, initialSort);
  const filters = useGetInitialFiltersFromUrl({
    filterKeys: ContractorCampaignsPageFilter,
  });
  const pagination = useGetPaginationFromUrl();
  const { filtersFromURL } = useGetFiltersUrl({
    urlFilters: [filters, pagination, sorting],
  });

  return filtersFromURL;
};
